import { render, staticRenderFns } from "./topics2.vue?vue&type=template&id=24b2836d&scoped=true&"
import script from "./topics2.vue?vue&type=script&lang=js&"
export * from "./topics2.vue?vue&type=script&lang=js&"
import style0 from "./topics2.vue?vue&type=style&index=0&id=24b2836d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2836d",
  null
  
)

export default component.exports